<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>练习</el-breadcrumb-item>
        </el-breadcrumb>

        <my-table height="80%" :columns="customColumns" :tableData="tableData" :loading="isLoading">
            <el-table-column prop="userSex" label="操作">
                <template slot-scope="scope">
                    <div class="d-flex fz14 col-29f cs-pit">
                        <div class="operate" @click="goUnderway(scope.row)">
                            <span v-buttonAuth="'system:exercise:underway'">进入练习</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </my-table>
        <div class="main-pagination">
            <Pagination :child-msg="pageInfo" @callFather="callFather"></Pagination>
        </div>
        <!-- <div class="main-table d-flex flex-align-center flex-column">
            <div class="mg-btm15 mg-tp20">当前共有{{ total }}题</div>
            <el-button type="primary" v-buttonAuth="'system:exercise:underway'" @click="goUnderway()">进入练习</el-button>
        </div> -->
    </div>
</template>

<script>
import api from '@/api/onlineTraining/classification';
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
export default {
    components: {
        MyTable,
        Pagination,
    },
    data () {
        return {
            total: 0,
            customColumns: [
                { label: '科目类别', prop: 'courseCategoryName' }
            ],
            isLoading: false,
            tableData: [],
            pageInfo: { currentPage: 1, pageSize: 10, total: 0 }, //  分页参数
        }
    },
    created () {
        this.getData();
    },

    methods: {

        goUnderway (item) {
            this.$router.replace({ path: '/participation/underway', query: { type: '2',courseCategoryId:item.courseCategoryId } })
        },
        callFather (data) {
            this.pageInfo.currentPage = data.currentPage;
            this.pageInfo.pageSize = data.pageSize;
            this.getData();
        },
        //  获取数据
        async getData () {
            const params = {
                pageNum: this.pageInfo.currentPage,
                pageSize: this.pageInfo.pageSize,
                stateSign:true 
            };
            const res = await api.courseCategoryPage(params);
            this.tableData = res.data.records;
            this.pageInfo.total = res.data.total;
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/participation/exercise.vue